// Mock data for Ovawell Autos Ltd - Hackney, East London

export const services = [
  {
    id: 1,
    title: "24/7 Roadside Breakdown & Recovery Hackney",
    description: "Emergency breakdown recovery service across Hackney and East London. Fast 30-minute response times covering all E postcodes and surrounding areas within 20 miles.",
    icon: "Wrench",
    features: ["24/7 Emergency Response Hackney", "Jump Start Service East London", "Flat Tyre Assistance", "Fuel Delivery Across E Postcodes"],
    link: "/services/breakdown-recovery"
  },
  {
    id: 2,
    title: "Car Auction Transport East London",
    description: "Professional vehicle collection from BCA Enfield, Manheim Colchester, and all auction houses within 20 miles of Hackney. Reliable door-to-door delivery across East London.",
    icon: "Car",
    features: ["Collection from All London Auctions", "Secure Transport East London", "Same-Day Delivery Available", "Insurance Included"],
    link: "/services/auction-transport"
  },
  {
    id: 3,
    title: "Vehicle Transportation Hackney & East London",
    description: "Expert car transportation service for running and non-running vehicles across Hackney, Islington, Tower Hamlets, Newham, and all East London boroughs within 20-mile radius.",
    icon: "Truck",
    features: ["Running & Non-Running Cars", "Door-to-Door Service Hackney", "East London Coverage", "Competitive Local Pricing"],
    link: "/services/vehicle-transport"
  },
  {
    id: 4,
    title: "Emergency Jump Start Services Hackney",
    description: "Quick 30-minute jump start service across Hackney and East London. Available 24/7 for immediate vehicle recovery in E1-E18 postcodes and surrounding areas.",
    icon: "Zap",
    features: ["Fast 30-Min Response Hackney", "Professional Equipment", "Battery Health Check East London", "No Hidden Charges"],
    link: "/services/jump-start"
  },
  {
    id: 5,
    title: "Vehicle Disposal & Recycling",
    description: "Free scrap car collection and end-of-life vehicle disposal across Hackney. Professional dismantling, Certificate of Destruction provided. Environmentally responsible recycling.",
    icon: "Recycle",
    features: ["Free Vehicle Collection", "Certificate of Destruction", "Professional Dismantling", "Eco-Friendly Recycling"],
    link: "/services/vehicle-disposal"
  },
  {
    id: 6,
    title: "Quality Used Car Parts",
    description: "Salvaged auto parts from professionally dismantled vehicles. Engines, gearboxes, body panels, and more. All parts tested and come with warranty.",
    icon: "Package",
    features: ["Tested Quality Parts", "Warranty Included", "Engines & Gearboxes", "Body Panels & Lights"],
    link: "/services/parts-sales"
  },
  {
    id: 7,
    title: "Mobile Mechanic Service",
    description: "Professional mobile mechanic comes to your home or work across Hackney and East London. On-site diagnostics, repairs, and servicing. No need to visit a garage.",
    icon: "Wrench",
    features: ["We Come To You", "On-Site Diagnostics", "Home/Work Service", "Same-Day Available"],
    link: "/services/mobile-mechanic"
  },
  {
    id: 8,
    title: "Vehicle Servicing & Maintenance",
    description: "Comprehensive vehicle servicing at our Hackney workshop. Full service, MOT preparation, diagnostics, and repairs. Qualified mechanics, quality parts, competitive pricing.",
    icon: "Settings",
    features: ["Full & Interim Service", "MOT Preparation", "Qualified Mechanics", "Quality Parts Used"],
    link: "/services/vehicle-servicing"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "James Mitchell",
    location: "Hackney, E8",
    rating: 5,
    text: "Brilliant service! Needed my car collected from BCA Enfield and delivered to Hackney. The team arrived within 40 minutes and the price was very competitive for East London.",
    service: "Auction Transport"
  },
  {
    id: 2,
    name: "Sarah Thompson",
    location: "Shoreditch, E2",
    rating: 5,
    text: "Called them at 11 PM with a breakdown on the A12 near Hackney. They arrived within 35 minutes! Best breakdown recovery service in East London.",
    service: "Breakdown Recovery"
  },
  {
    id: 3,
    name: "David Roberts",
    location: "Stratford, E15",
    rating: 5,
    text: "Used Ovawell for transporting a non-runner from Colchester to Stratford. Excellent communication throughout and very professional. Highly recommend for East London.",
    service: "Vehicle Transport"
  },
  {
    id: 4,
    name: "Emma Williams",
    location: "Dalston, E8",
    rating: 5,
    text: "Battery died in Hackney car park at 6 AM. They came out quickly, jump-started my car in 10 minutes. Great local service for East London!",
    service: "Jump Start"
  }
];

export const coverageAreas = [
  "Hackney (E5, E8, E9)",
  "Shoreditch & Hoxton (E1, E2)",
  "Bethnal Green (E2)",
  "Bow & Mile End (E3)",
  "Stratford & West Ham (E15, E13)",
  "Leyton & Walthamstow (E10, E17)",
  "Islington (N1, N7)",
  "Tower Hamlets (E14)",
  "Newham & East Ham (E6, E12)",
  "Ilford & Barking (IG postcodes)",
  "Plus 20-Mile Radius from Hackney"
];

export const faqs = [
  {
    id: 1,
    question: "How quickly can you respond to breakdowns in Hackney?",
    answer: "Our average response time for emergency breakdowns in Hackney and East London is 30-45 minutes. We're strategically located in Hackney to serve all E postcodes quickly, 24/7."
  },
  {
    id: 2,
    question: "Do you cover all of East London and surrounding areas?",
    answer: "Yes! We cover all Hackney postcodes (E5, E8, E9), Shoreditch, Stratford, Bethnal Green, and all areas within a 20-mile radius including Islington, Tower Hamlets, Newham, Walthamstow, and into Essex."
  },
  {
    id: 3,
    question: "Can you transport non-running vehicles in East London?",
    answer: "Absolutely! We specialize in transporting both running and non-running vehicles across East London. Our equipment is designed to safely handle cars that won't start or roll within the Hackney area and 20-mile radius."
  },
  {
    id: 4,
    question: "Which auction houses do you collect from near Hackney?",
    answer: "We collect from BCA Enfield, Manheim Colchester, Aston Barclay Chelmsford, and all major auction houses within 20 miles of Hackney. Same-day delivery available to East London."
  },
  {
    id: 5,
    question: "How do I get a quote for car transport in Hackney?",
    answer: "Simply fill out our quote form with your pickup and drop-off postcodes in the Hackney/East London area. We'll respond within 30 minutes with a competitive local quote."
  },
  {
    id: 6,
    question: "What makes you the best car recovery service in East London?",
    answer: "We're locally based in Hackney with 30-minute response times, 24/7 availability, competitive East London prices, and comprehensive insurance. Our team knows every street in the E postcodes and surrounding areas."
  }
];

export const companyInfo = {
  name: "Ovawell Autos Ltd",
  tagline: "Hackney's Trusted Car Recovery & Transport Service",
  location: "Based in Hackney, Serving East London",
  serviceArea: "Hackney & 20-Mile Radius",
  phone: "07492 639223",
  emergencyPhone: "07492 639223",
  whatsappNumber: "447492639223",
  email: "ovawellautoslimited@outlook.com",
  address: "Hackney, East London, UK",
  hours: "24/7 Emergency Service - Hackney & East London"
};
